export var PrematterType;
(function (PrematterType) {
    PrematterType["LegalInformation"] = "legal-information";
    PrematterType["LawyerConnection"] = "lawyer-connection";
})(PrematterType || (PrematterType = {}));
export var AiLawyer;
(function (AiLawyer) {
    AiLawyer["Maxwell"] = "Maxwell";
    AiLawyer["Emma"] = "Emma";
    AiLawyer["Watson"] = "Watson";
    AiLawyer["Amy"] = "Amy";
    AiLawyer["Bruce"] = "Bruce";
    AiLawyer["Claire"] = "Claire";
})(AiLawyer || (AiLawyer = {}));
export var LegalCaseState;
(function (LegalCaseState) {
    LegalCaseState["MatterTypes"] = "matter-types";
    LegalCaseState["Location"] = "location";
    LegalCaseState["PreparingQuestions"] = "preparing-questions";
    LegalCaseState["Questions"] = "questions";
    LegalCaseState["PreparingForm"] = "preparing-form";
    LegalCaseState["Form"] = "form";
    LegalCaseState["ExtendedForm"] = "extended-form";
    LegalCaseState["ContactForm"] = "contact-form";
    LegalCaseState["AuthCheck"] = "auth-check";
    LegalCaseState["PreparingReport"] = "preparing-report";
    LegalCaseState["ReportReady"] = "report-ready";
    LegalCaseState["VerificationPending"] = "verification-pending";
    LegalCaseState["Verified"] = "verified";
    LegalCaseState["ReviewQuestionnaire"] = "review-questionnaire";
    LegalCaseState["Paywall"] = "paywall";
    LegalCaseState["LawyerSubmissionReady"] = "lawyer-submission-ready";
})(LegalCaseState || (LegalCaseState = {}));
export var LegalCaseEvent;
(function (LegalCaseEvent) {
    LegalCaseEvent["StateChange"] = "state-change";
    LegalCaseEvent["Message"] = "message";
})(LegalCaseEvent || (LegalCaseEvent = {}));
export var MessageType;
(function (MessageType) {
    MessageType["Chat"] = "chat";
    MessageType["Location"] = "location";
    MessageType["Confirmation"] = "confirmation";
    MessageType["Permission"] = "permission";
    MessageType["ClientIntakeForm"] = "client-intake-form";
    MessageType["Closed"] = "closed";
    MessageType["ContactInformation"] = "contact-information";
    MessageType["Refresh"] = "refresh";
    MessageType["EmailOpened"] = "email-opened";
    MessageType["Error"] = "error";
    MessageType["Action"] = "action";
    MessageType["Review"] = "review";
    MessageType["System"] = "system";
})(MessageType || (MessageType = {}));
export var EstatePlanningState;
(function (EstatePlanningState) {
    EstatePlanningState["Ready"] = "ready";
    EstatePlanningState["Complete"] = "complete";
    EstatePlanningState["InProgress"] = "in-progress";
})(EstatePlanningState || (EstatePlanningState = {}));
//# sourceMappingURL=prematter.js.map